export default "__VITE_ASSET__C83Klja___"